/**
 * Predicate for routes that should hide global app chrome (header + footer)
 * to give the page a fully immersive feel.
 *
 * Covers the entire challenge experience — the list (`/challenges`), the gate
 * (`/challenges/:id`), and the per-run flow (`.../setup`, `.../play`,
 * `.../result`) — so students are never pulled out of the gamified context by
 * the standard site chrome (logo bar, footer subscribe form, etc.).
 *
 * @example
 * if (isImmersiveChallengeRoute(location.pathname)) return null;
 */
export function isImmersiveChallengeRoute(pathname: string): boolean {
  return pathname.startsWith("/challenges");
}
